import React from "react";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import downloadFiles from "../../../../Common/FilesRelevent/DownloadFiles";
import NotFound from "../../../../CustomComponents/AllLoader/NotFound";
import DisplayFileProper from "../../../../Common/FilesRelevent/DisplayFileProper";

export default function AllFiles({ foldervalues }) {
  return (
    <div>
      <div className="row grid-row">
        {Array.isArray(foldervalues?.files) &&
          foldervalues.files.length != 0 ? (
          <>
            {foldervalues?.files?.map((item, index) => (
              <div className="col-md-3 col-6" key={index}>
                <div className="ic-folder1">
                  <div className="ic-btn ">
                    <h5>{item?.name}</h5>
                    <div className="d-flex action-btn">
                      <button onClick={() => downloadFiles(item?.file)}>
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/common/download-icon-black.png`}
                          alt="Download"
                        />
                      </button>
                      {/* <button className="btn">
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/common/dots-vertical.svg`}
                          alt=""
                        />
                      </button> */}
                    </div>
                  </div>
                  <div className="ic-attach ic-border-img-height">
                    <DisplayFileProper item={item} />
                    {/* <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/common/ic_attachment.png`}
                      alt=""
                    /> */}
                  </div>
                </div>
              </div>
            ))}
          </>
        ) : (
          <NotFound title="No files found" />
        )}

        {/* <>
                    <div className="col-md-3">
                        <div className="ic-folder1">
                            <div className='ic-btn'>
                                <h5>Brand guidelines.zip</h5>
                                <button className='btn'><img src={`${CloudStorage.cloudurl}/Assets/Images/common/dots-vertical.svg`} alt="" /></button>
                            </div>
                            <div className="ic-attach">
                                <img src={`${CloudStorage.cloudurl}/Assets/Images/common/ic_attachment.png`} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="ic-folder1">
                            <div className='ic-btn'>
                                <h5>Brand guidelines.zip</h5>
                                <button className='btn'><img src={`${CloudStorage.cloudurl}/Assets/Images/common/dots-vertical.svg`} alt="" /></button>
                            </div>
                            <div className="ic-attach">
                                <img src={`${CloudStorage.cloudurl}/Assets/Images/common/ic_attachment.png`} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="ic-folder1">
                            <div className='ic-btn'>
                                <h5>Brand guidelines.zip</h5>
                                <button className='btn'><img src={`${CloudStorage.cloudurl}/Assets/Images/common/dots-vertical.svg`} alt="" /></button>
                            </div>
                            <div className="ic-attach">
                                <img src={`${CloudStorage.cloudurl}/Assets/Images/common/ic_attachment.png`} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="ic-folder1">
                            <div className='ic-btn'>
                                <h5>Brand guidelines.zip</h5>
                                <button className='btn'><img src={`${CloudStorage.cloudurl}/Assets/Images/common/dots-vertical.svg`} alt="" /></button>
                            </div>
                            <div className="ic-attach">
                                <img src={`${CloudStorage.cloudurl}/Assets/Images/common/ic_attachment.png`} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="ic-folder1">
                            <div className='ic-btn'>
                                <h5>Brand guidelines.zip</h5>
                                <button className='btn'><img src={`${CloudStorage.cloudurl}/Assets/Images/common/dots-vertical.svg`} alt="" /></button>
                            </div>
                            <div className="ic-attach">
                                <img src={`${CloudStorage.cloudurl}/Assets/Images/common/ic_attachment.png`} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="ic-folder1">
                            <div className='ic-btn'>
                                <h5>Brand guidelines.zip</h5>
                                <button className='btn'><img src={`${CloudStorage.cloudurl}/Assets/Images/common/dots-vertical.svg`} alt="" /></button>
                            </div>
                            <div className="ic-attach">
                                <img src={`${CloudStorage.cloudurl}/Assets/Images/common/ic_attachment.png`} alt="" />
                            </div>
                        </div>
                    </div>
                </> */}
      </div>
    </div>
  );
}
